var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('index'),_c('swiper'),_c('keep-alive',{attrs:{"include":"Home"}},[_c('router-view')],1),_c('bottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }